
export * from "./allergy/index";
export * from "./booking/index";
export * from "./dashboard/index";
export * from "./immunization/index";
export * from "./lab/index";
export * from "./prescriptions/index";
export * from "./radiology/index";
export * from "./login/index";
export * from "./kiosklogin/index";

export * from "./Register/index";

export * from "./GuestAppointment/index";

export * from "./ServicePayment/index";
export * from "./SearchServicePayment/index";
export * from "./AdvancePayment/index";

export * from "./ForgotPassword/index";
export * from "./SignUp/index";
export * from "./ChangePassword/index";
export * from "./FeedBack/index";
export * from "./PatientProfile/index";

export * from "./Appointments/index";
export * from "./Lab/index";
export * from "./MedicalReport/index";
export * from "./MedicalRequest/index";

export * from "./shared/shared.module";
export * from "./allergy/allergy.module";
export * from "./booking/booking.module";
export * from "./dashboard/dashboard.module";
export * from "./immunization/immunization.module";
export * from "./lab/lab.module";
export * from "./prescriptions/prescriptions.module";
export * from "./radiology/radiology.module";
export * from "./Appointments/Appointments.module";
export * from "./login/login.module";
export * from "./kiosklogin/kiosklogin.module";

export * from "./PatientProfile/PatientProfile.module";  
export * from "./Register/Registration.module";
export * from "./GuestAppointment/GuestAppointment.module";
export * from "./ServicePayment/ServicePayment.module";
export * from "./SearchServicePayment/SearchServicePayment.module";
export * from "./advancepayment/advancepayment.module";
export * from "./ForgotPassword/ForgotPassword.module";  
export * from "./SignUp/SignUp.module";  
export * from "./ChangePassword/ChangePassword.module";
export * from "./FeedBack/FeedBack.module";
export * from "./Security/security.service";
export * from "./Model/Utilities/Currencydetails";
export * from "./insurance/index";
export * from "./insurance/insurance.module";
export * from "./searchscreen/index";
export * from "./searchscreen/searchscreen.module";



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/appindex.ts